import { APP_INITIALIZER } from '@angular/core';

import { take } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { settings } from '@environment';

export function preloadLanguages(transloco: TranslocoService) {
  return function () {
    for (const lang of settings.supportedLanguages) {
      transloco.load(lang).pipe(take(1));

      if (lang === settings.defaultLanguage) {
        transloco.setActiveLang(lang);
      }
    }
  };
}

export const preload = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: preloadLanguages,
  deps: [TranslocoService],
};
